import {saveQuestionDataInCache, getAnswersDataFromCache, saveData, getData} from 'helpers/cache/cacheManager'

function saveOeqQuestionData(submitData, session) {
	saveQuestionDataInCache(
		submitData.answers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)
}

async function getOeqAnswersData(questionData, session) {
	const newAnswers = questionData.options.map(option => option.key)

	const answersFromCache = await getAnswersDataFromCache(
		newAnswers,
		session.presentation_uid,
		session.session_uid,
		session.join_token,
		session.pincode
	)

	return answersFromCache.map(answer => answer.value)
}

function buildKey(session, slideId) {
	return `${session.session_uid}_${slideId}`
}

function saveOeqExtraData(submitData, session, slideData) {
	const key = buildKey(session, slideData.slideIndex)

	saveData(
		key,
		{
			audioUid: submitData.audioUid,
		},
	)
}

async function getOeqExtraData(session, slideData) {
	const key = buildKey(session, slideData.slideId)

	const extraData = await getData(
		key,
	)

	return extraData
}

export {
	saveOeqQuestionData,
	getOeqAnswersData,
	saveOeqExtraData,
	getOeqExtraData,
}
